module.exports = __webpack_public_path__ + "static/choppedHero-c3643be30ae7d5b1f747a006eef086a9.jpg";